import React, { useState } from "react";
import { Box, Grid, Typography, useTheme, Paper, Button } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useNavigate, useParams } from "react-router-dom";
import fields from "../fields";
import { useAuth } from "../../../services/auth";
import { useClient } from "../Provider";
import ModalBox from "../../../ui/ModalBox";

function BoxInfo({ client = [] }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const { role } = useAuth();
  const { id } = useParams();
  const { generateKey, deleteKey } = useClient();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const getData = (data) => {
    switch (data) {
      case "companyName":
        return client?.company?.companyName ? client?.company?.companyName : "";
      default:
        break;
    }
  };

  const handleGenerateKey = async () => {
    try {
      setGenerating(true);
      await generateKey(id);
      setOpenConfirm(false);
    } catch (e) {
      console.log(e);
    } finally {
      setGenerating(false);
    }
  };

  const handleDeleteKey = async () => {
    try {
      setDeleting(true);
      await deleteKey(id);
      setOpenDeleteConfirm(false);
    } catch (e) {
      console.log(e);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: theme.dimensions.padding,
        mt: theme.dimensions.mt,
        mb: theme.dimensions.mb,
        background: theme.color.PaperbgColor,
        width: "90%",
      }}>
      <Typography variant="Poster" component="h4" gutterBottom>
        Client Information
      </Typography>
      <Grid container>
        {fields.map((f, index) => {
          if (f.editOnly) return [];
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              mt={2}
              key={index}
              sx={{ fontSize: "14px" }}>
              <span style={{ color: theme.color.PaperlabelColor }}>
                {f.label} :{" "}
              </span>
              <span>
                {client?.[f?.name] && client?.[f?.name]}
                {getData(f.viewLabel2)}
                {f.name === "isActive" &&
                  (client?.isActive ? (
                    <span style={{ color: "#4AA785" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Active
                    </span>
                  ) : (
                    <span style={{ color: "rgba(0, 0, 0, 0.4)" }}>
                      <FiberManualRecordIcon
                        fontSize="small"
                        sx={{ fontSize: 10, mr: 0.2 }}
                      />
                      Inactive
                    </span>
                  ))}
              </span>
            </Grid>
          );
        })}
        <Grid item xs={12} sm={12} md={4} mt={2} sx={{ fontSize: "14px" }}>
          <span style={{ color: theme.color.PaperlabelColor }}>
            Parking Key :{" "}
          </span>
          <span>
            {client?.parkingKey || "No parking key yet"}
            {client?.parkingKey ? (
              <>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setOpenConfirm(true)}
                  sx={{
                    ml: 1,
                    background: theme.color.dark,
                    color: "white",
                    "&:hover": {
                      background: `${theme.color.gray500}`,
                      // color: `${theme.color.dark}`,
                    },
                  }}>
                  Generate Key
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setOpenDeleteConfirm(true)}
                  sx={{
                    ml: 1,
                    background: "#FF4747",
                    color: "white",
                    "&:hover": { background: "#e63946" },
                  }}>
                  Delete Key
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                size="small"
                onClick={handleGenerateKey}
                disabled={generating}
                sx={{
                  ml: 1,
                  background: theme.color.blackBackground,
                  color: "white",
                  "&:hover": { background: `${theme.color.black}` },
                }}>
                {generating ? "Generating..." : "Generate Key"}
              </Button>
            )}
          </span>
        </Grid>
      </Grid>

      {role === "Admin" && (
        <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
          <Button
            onClick={() => navigate("edit")}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.black}` },
            }}>
            Edit
          </Button>
        </Box>
      )}
      {role === "Company" && (
        <Box sx={{ display: "flex", justifyContent: "end" }} mr={2}>
          <Button
            onClick={() => navigate("edit")}
            sx={{
              background: theme.color.blackBackground,
              color: "white",
              "&:hover": { background: `${theme.color.black}` },
            }}>
            Edit
          </Button>
        </Box>
      )}

      <ModalBox
        open={openConfirm}
        operation="delete"
        handleClose={() => setOpenConfirm(false)}
        handleOperation={handleGenerateKey}
        text="Are you sure you want to regenerate the parking key?"
        btnLabel={generating ? "Generating..." : "Generate"}
      />

      <ModalBox
        open={openDeleteConfirm}
        operation="delete"
        handleClose={() => setOpenDeleteConfirm(false)}
        handleOperation={handleDeleteKey}
        text="Are you sure you want to delete the parking key?"
        btnLabel={deleting ? "Deleting..." : "Delete"}
      />
    </Paper>
  );
}

export default BoxInfo;
